/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddTunnelValideurCommand,
  CommissionGarantieDetailDto,
  CreateCommissionGarantieCommand,
  CreateFraisTunnelCommand,
  CreateGarantieTunnelCommand,
  CreateSupportTunnelCommand,
  CreateTunnelCommand,
  DupliquerTunnelCommand,
  DupliquerTunnelResponse,
  ErrorResponse,
  FraisTunnelDetailDto,
  FunnelDetailDto,
  GarantieTarifDto,
  GarantieTunnelDetailDto,
  GarantieTunnelListItemDto,
  GenericLinkPlateformesCommand,
  GetFacetsResponse,
  GetFraisParcConfigResponse,
  GetFraisTunnelResponse,
  GetFunnelListResponse,
  GetFunnels404Response,
  GetGarantieCommissionsResponse,
  GetGenericListCommandDto,
  GetTunnelAdminListResponse,
  GetTunnelAuditHistoryResponse,
  GetTunnelValidationConfigResponse,
  ListValideursDisponiblesResponse,
  OperationResponse,
  SaveFraisParcConfigCommand,
  SetCourtierValidationOptionnelleCommand,
  SetTunnelValideurCourtiersCommand,
  SetValidationOptionnellePourTousCommand,
  SetValidationRequiseCommand,
  SetVariablesValideurCommand,
  SupportTunnelDto,
  TarificationDetailsDto,
  UpdateCommissionGarantieCommand,
  UpdateFraisTunnelCommand,
  UpdateFunnelCommand,
  UpdateGarantieTunnelCommand,
  UpdateSupportTunnelCommand,
} from '../models/index';
import {
    AddTunnelValideurCommandFromJSON,
    AddTunnelValideurCommandToJSON,
    CommissionGarantieDetailDtoFromJSON,
    CommissionGarantieDetailDtoToJSON,
    CreateCommissionGarantieCommandFromJSON,
    CreateCommissionGarantieCommandToJSON,
    CreateFraisTunnelCommandFromJSON,
    CreateFraisTunnelCommandToJSON,
    CreateGarantieTunnelCommandFromJSON,
    CreateGarantieTunnelCommandToJSON,
    CreateSupportTunnelCommandFromJSON,
    CreateSupportTunnelCommandToJSON,
    CreateTunnelCommandFromJSON,
    CreateTunnelCommandToJSON,
    DupliquerTunnelCommandFromJSON,
    DupliquerTunnelCommandToJSON,
    DupliquerTunnelResponseFromJSON,
    DupliquerTunnelResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FraisTunnelDetailDtoFromJSON,
    FraisTunnelDetailDtoToJSON,
    FunnelDetailDtoFromJSON,
    FunnelDetailDtoToJSON,
    GarantieTarifDtoFromJSON,
    GarantieTarifDtoToJSON,
    GarantieTunnelDetailDtoFromJSON,
    GarantieTunnelDetailDtoToJSON,
    GarantieTunnelListItemDtoFromJSON,
    GarantieTunnelListItemDtoToJSON,
    GenericLinkPlateformesCommandFromJSON,
    GenericLinkPlateformesCommandToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetFraisParcConfigResponseFromJSON,
    GetFraisParcConfigResponseToJSON,
    GetFraisTunnelResponseFromJSON,
    GetFraisTunnelResponseToJSON,
    GetFunnelListResponseFromJSON,
    GetFunnelListResponseToJSON,
    GetFunnels404ResponseFromJSON,
    GetFunnels404ResponseToJSON,
    GetGarantieCommissionsResponseFromJSON,
    GetGarantieCommissionsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetTunnelAdminListResponseFromJSON,
    GetTunnelAdminListResponseToJSON,
    GetTunnelAuditHistoryResponseFromJSON,
    GetTunnelAuditHistoryResponseToJSON,
    GetTunnelValidationConfigResponseFromJSON,
    GetTunnelValidationConfigResponseToJSON,
    ListValideursDisponiblesResponseFromJSON,
    ListValideursDisponiblesResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SaveFraisParcConfigCommandFromJSON,
    SaveFraisParcConfigCommandToJSON,
    SetCourtierValidationOptionnelleCommandFromJSON,
    SetCourtierValidationOptionnelleCommandToJSON,
    SetTunnelValideurCourtiersCommandFromJSON,
    SetTunnelValideurCourtiersCommandToJSON,
    SetValidationOptionnellePourTousCommandFromJSON,
    SetValidationOptionnellePourTousCommandToJSON,
    SetValidationRequiseCommandFromJSON,
    SetValidationRequiseCommandToJSON,
    SetVariablesValideurCommandFromJSON,
    SetVariablesValideurCommandToJSON,
    SupportTunnelDtoFromJSON,
    SupportTunnelDtoToJSON,
    TarificationDetailsDtoFromJSON,
    TarificationDetailsDtoToJSON,
    UpdateCommissionGarantieCommandFromJSON,
    UpdateCommissionGarantieCommandToJSON,
    UpdateFraisTunnelCommandFromJSON,
    UpdateFraisTunnelCommandToJSON,
    UpdateFunnelCommandFromJSON,
    UpdateFunnelCommandToJSON,
    UpdateGarantieTunnelCommandFromJSON,
    UpdateGarantieTunnelCommandToJSON,
    UpdateSupportTunnelCommandFromJSON,
    UpdateSupportTunnelCommandToJSON,
} from '../models/index';

export interface AddFunnelValidatorRequest {
    tunnelId: string;
    addTunnelValideurCommand: AddTunnelValideurCommand;
}

export interface CreateFunnelRequest {
    createTunnelCommand: CreateTunnelCommand;
}

export interface CreateFunnelFeeRequest {
    createFraisTunnelCommand: CreateFraisTunnelCommand;
}

export interface CreateFunnelGuaranteeRequest {
    createGarantieTunnelCommand: CreateGarantieTunnelCommand;
}

export interface CreateFunnelSupportRequest {
    createSupportTunnelCommand: CreateSupportTunnelCommand;
}

export interface CreateGuaranteeCommissionRequest {
    createCommissionGarantieCommand: CreateCommissionGarantieCommand;
}

export interface DeleteFunnelRequest {
    funnelId: string;
}

export interface DeleteFunnelFeeRequest {
    id: string;
}

export interface DeleteFunnelSupportRequest {
    supportTunnelId: string;
}

export interface DeleteGuaranteeCommissionRequest {
    id: string;
}

export interface DeleteGuaranteeTunnelRequest {
    garantieTunnelId: string;
}

export interface DisableFunnelRequest {
    tunnelId: string;
}

export interface DisableGuaranteeTunnelRequest {
    garantieTunnelId: string;
}

export interface DuplicateFunnelRequest {
    tunnelId: string;
    dupliquerTunnelCommand?: DupliquerTunnelCommand;
}

export interface EnableFunnelRequest {
    tunnelId: string;
}

export interface EnableGuaranteeTunnelRequest {
    garantieTunnelId: string;
}

export interface GetAdminTunnelListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminTunnelsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetFunnelAvailableValidatorsRequest {
    tunnelId: string;
    plateformeId: string;
}

export interface GetFunnelDetailRequest {
    funnelId: string;
}

export interface GetFunnelFeeRequest {
    fraisTunnelId: string;
}

export interface GetFunnelFeesRequest {
    tunnelId: string;
}

export interface GetFunnelGuaranteeRequest {
    garantieTunnelId: string;
}

export interface GetFunnelGuaranteePricingDetailsRequest {
    garantieTunnelId: string;
}

export interface GetFunnelGuaranteesRequest {
    tunnelId: string;
    isTunnelGLI?: boolean;
}

export interface GetFunnelParkFeesConfigRequest {
    tunnelId: string;
}

export interface GetFunnelPricingDetailsRequest {
    tunnelId: string;
}

export interface GetFunnelSupportsRequest {
    tunnelId: string;
    isTunnelGLI: boolean;
}

export interface GetFunnelValidationConfigRequest {
    tunnelId: string;
}

export interface GetFunnelsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetGuaranteeCommissionRequest {
    commissionGarantieTunnelId: string;
}

export interface GetGuaranteeCommissionsRequest {
    garantieTunnelId: string;
}

export interface GetTunnelAuditHistoryRequest {
    tunnelId: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface LinkPlateformesRequest {
    funnelId: string;
    genericLinkPlateformesCommand: GenericLinkPlateformesCommand;
}

export interface RemoveFunnelValidatorRequest {
    tunnelId: string;
    valideurId: string;
}

export interface ResetFunnelParkFeeConfigRequest {
    tunnelId: string;
    remunerationTunnelId: string;
}

export interface SaveFunnelParkFeeConfigRequest {
    tunnelId: string;
    remunerationTunnelId: string;
    saveFraisParcConfigCommand: SaveFraisParcConfigCommand;
}

export interface SetFunnelBrokerOptionalValidationRequest {
    tunnelId: string;
    courtierId: string;
    setCourtierValidationOptionnelleCommand: SetCourtierValidationOptionnelleCommand;
}

export interface SetFunnelMainValidatorRequest {
    tunnelId: string;
    valideurId: string;
}

export interface SetFunnelOptionalValidationForAllRequest {
    tunnelId: string;
    setValidationOptionnellePourTousCommand: SetValidationOptionnellePourTousCommand;
}

export interface SetFunnelValidationRequiredRequest {
    tunnelId: string;
    setValidationRequiseCommand: SetValidationRequiseCommand;
}

export interface SetFunnelValidatorBrokersRequest {
    tunnelId: string;
    valideurId: string;
    setTunnelValideurCourtiersCommand: SetTunnelValideurCourtiersCommand;
}

export interface SetFunnelValidatorVariablesRequest {
    tunnelId: string;
    setVariablesValideurCommand: SetVariablesValideurCommand;
}

export interface UpdateFunnelRequest {
    updateFunnelCommand: UpdateFunnelCommand;
}

export interface UpdateFunnelFeeRequest {
    fraisTunnelId: string;
    updateFraisTunnelCommand: UpdateFraisTunnelCommand;
}

export interface UpdateFunnelGuaranteeRequest {
    updateGarantieTunnelCommand: UpdateGarantieTunnelCommand;
}

export interface UpdateFunnelSupportRequest {
    updateSupportTunnelCommand: UpdateSupportTunnelCommand;
}

export interface UpdateGuaranteeCommissionRequest {
    commissionGarantieTunnelId: string;
    updateCommissionGarantieCommand: UpdateCommissionGarantieCommand;
}

/**
 * 
 */
export class FunnelsApi extends runtime.BaseAPI {

    /**
     * Ajouter un valideur au tunnel
     */
    async addFunnelValidatorRaw(requestParameters: AddFunnelValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling addFunnelValidator().'
            );
        }

        if (requestParameters['addTunnelValideurCommand'] == null) {
            throw new runtime.RequiredError(
                'addTunnelValideurCommand',
                'Required parameter "addTunnelValideurCommand" was null or undefined when calling addFunnelValidator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/valideurs`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTunnelValideurCommandToJSON(requestParameters['addTunnelValideurCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Ajouter un valideur au tunnel
     */
    async addFunnelValidator(requestParameters: AddFunnelValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addFunnelValidatorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Création d\'un tunnel vierge (ni garantie, ni frais, ni support, ni plateforme). La réponse porte l\'identifiant du tunnel créé dans id, pour enchaîner sur son paramétrage. Permission BackOffice.Tunnels.Create. Les refus fonctionnels (code déjà utilisé, produit introuvable, compte bancaire n\'appartenant pas au bénéficiaire) arrivent en 200 avec isSuccess à false et un errorMessage à afficher tel quel. 
     * Créer un tunnel
     */
    async createFunnelRaw(requestParameters: CreateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'createTunnelCommand',
                'Required parameter "createTunnelCommand" was null or undefined when calling createFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTunnelCommandToJSON(requestParameters['createTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Création d\'un tunnel vierge (ni garantie, ni frais, ni support, ni plateforme). La réponse porte l\'identifiant du tunnel créé dans id, pour enchaîner sur son paramétrage. Permission BackOffice.Tunnels.Create. Les refus fonctionnels (code déjà utilisé, produit introuvable, compte bancaire n\'appartenant pas au bénéficiaire) arrivent en 200 avec isSuccess à false et un errorMessage à afficher tel quel. 
     * Créer un tunnel
     */
    async createFunnel(requestParameters: CreateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ajouter un frais au tunnel
     */
    async createFunnelFeeRaw(requestParameters: CreateFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createFraisTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'createFraisTunnelCommand',
                'Required parameter "createFraisTunnelCommand" was null or undefined when calling createFunnelFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/remunerations-tunnels/optim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFraisTunnelCommandToJSON(requestParameters['createFraisTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Ajouter un frais au tunnel
     */
    async createFunnelFee(requestParameters: CreateFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createFunnelFeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ajouter une garantie au tunnel
     */
    async createFunnelGuaranteeRaw(requestParameters: CreateFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GarantieTunnelListItemDto>> {
        if (requestParameters['createGarantieTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'createGarantieTunnelCommand',
                'Required parameter "createGarantieTunnelCommand" was null or undefined when calling createFunnelGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/optim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGarantieTunnelCommandToJSON(requestParameters['createGarantieTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GarantieTunnelListItemDtoFromJSON(jsonValue));
    }

    /**
     * Ajouter une garantie au tunnel
     */
    async createFunnelGuarantee(requestParameters: CreateFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GarantieTunnelListItemDto> {
        const response = await this.createFunnelGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autoriser un support sur le tunnel
     */
    async createFunnelSupportRaw(requestParameters: CreateFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportTunnelDto>> {
        if (requestParameters['createSupportTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'createSupportTunnelCommand',
                'Required parameter "createSupportTunnelCommand" was null or undefined when calling createFunnelSupport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/supports-tunnels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupportTunnelCommandToJSON(requestParameters['createSupportTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTunnelDtoFromJSON(jsonValue));
    }

    /**
     * Autoriser un support sur le tunnel
     */
    async createFunnelSupport(requestParameters: CreateFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportTunnelDto> {
        const response = await this.createFunnelSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ajouter une commission à une garantie
     */
    async createGuaranteeCommissionRaw(requestParameters: CreateGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createCommissionGarantieCommand'] == null) {
            throw new runtime.RequiredError(
                'createCommissionGarantieCommand',
                'Required parameter "createCommissionGarantieCommand" was null or undefined when calling createGuaranteeCommission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/remunerations-garanties-tunnels/optim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCommissionGarantieCommandToJSON(requestParameters['createCommissionGarantieCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Ajouter une commission à une garantie
     */
    async createGuaranteeCommission(requestParameters: CreateGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createGuaranteeCommissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Suppression logique. Permission BackOffice.AdminTunnels.Delete, réservée aux administrateurs (le rôle est revérifié à l\'exécution). Refusée dès qu\'un devis, contrat, contrat collectif, panier emprunteur, mandat ou lead partenaire pointe le tunnel : errorMessage énumère alors ce qui bloque et propose la désactivation. Les garanties et leurs enfants partent avec le tunnel, sans marquage individuel. 
     * Supprimer un tunnel
     */
    async deleteFunnelRaw(requestParameters: DeleteFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['funnelId'] == null) {
            throw new runtime.RequiredError(
                'funnelId',
                'Required parameter "funnelId" was null or undefined when calling deleteFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{funnelId}`.replace(`{${"funnelId"}}`, encodeURIComponent(String(requestParameters['funnelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Suppression logique. Permission BackOffice.AdminTunnels.Delete, réservée aux administrateurs (le rôle est revérifié à l\'exécution). Refusée dès qu\'un devis, contrat, contrat collectif, panier emprunteur, mandat ou lead partenaire pointe le tunnel : errorMessage énumère alors ce qui bloque et propose la désactivation. Les garanties et leurs enfants partent avec le tunnel, sans marquage individuel. 
     * Supprimer un tunnel
     */
    async deleteFunnel(requestParameters: DeleteFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer un frais du tunnel
     */
    async deleteFunnelFeeRaw(requestParameters: DeleteFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFunnelFee().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-tunnels/remuneration`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer un frais du tunnel
     */
    async deleteFunnelFee(requestParameters: DeleteFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteFunnelFeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retirer un support autorisé
     */
    async deleteFunnelSupportRaw(requestParameters: DeleteFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['supportTunnelId'] == null) {
            throw new runtime.RequiredError(
                'supportTunnelId',
                'Required parameter "supportTunnelId" was null or undefined when calling deleteFunnelSupport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['supportTunnelId'] != null) {
            queryParameters['supportTunnelId'] = requestParameters['supportTunnelId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/supports-tunnels`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retirer un support autorisé
     */
    async deleteFunnelSupport(requestParameters: DeleteFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFunnelSupportRaw(requestParameters, initOverrides);
    }

    /**
     * Supprimer une commission de garantie
     */
    async deleteGuaranteeCommissionRaw(requestParameters: DeleteGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteGuaranteeCommission().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-garanties-tunnels`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer une commission de garantie
     */
    async deleteGuaranteeCommission(requestParameters: DeleteGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteGuaranteeCommissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer une garantie du tunnel (suppression logique, conservée sur les devis et contrats existants)
     */
    async deleteGuaranteeTunnelRaw(requestParameters: DeleteGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling deleteGuaranteeTunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/{garantieTunnelId}`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer une garantie du tunnel (suppression logique, conservée sur les devis et contrats existants)
     */
    async deleteGuaranteeTunnel(requestParameters: DeleteGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteGuaranteeTunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Désactiver un tunnel
     */
    async disableFunnelRaw(requestParameters: DisableFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling disableFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/disable`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Désactiver un tunnel
     */
    async disableFunnel(requestParameters: DisableFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.disableFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Désactiver une garantie du tunnel (retirée du tunnel et de la tarification, sans suppression)
     */
    async disableGuaranteeTunnelRaw(requestParameters: DisableGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling disableGuaranteeTunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/{garantieTunnelId}/disable`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Désactiver une garantie du tunnel (retirée du tunnel et de la tarification, sans suppression)
     */
    async disableGuaranteeTunnel(requestParameters: DisableGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.disableGuaranteeTunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplique un tunnel (garanties, franchises, plafonds, exclusions, commissions, co/ré-assureurs, frais, supports, plateformes autorisées). La copie est créée DÉSACTIVÉE. Permission BackOffice.AdminTunnels.Duplicate, réservée aux administrateurs (le rôle est revérifié à l\'exécution). L\'opération n\'est pas idempotente : deux appels créent deux tunnels. Pas de retry automatique — en cas d\'échec, rien n\'a été créé (transactionnel). 
     * Dupliquer un tunnel
     */
    async duplicateFunnelRaw(requestParameters: DuplicateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DupliquerTunnelResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling duplicateFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/dupliquer`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DupliquerTunnelCommandToJSON(requestParameters['dupliquerTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DupliquerTunnelResponseFromJSON(jsonValue));
    }

    /**
     * Duplique un tunnel (garanties, franchises, plafonds, exclusions, commissions, co/ré-assureurs, frais, supports, plateformes autorisées). La copie est créée DÉSACTIVÉE. Permission BackOffice.AdminTunnels.Duplicate, réservée aux administrateurs (le rôle est revérifié à l\'exécution). L\'opération n\'est pas idempotente : deux appels créent deux tunnels. Pas de retry automatique — en cas d\'échec, rien n\'a été créé (transactionnel). 
     * Dupliquer un tunnel
     */
    async duplicateFunnel(requestParameters: DuplicateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DupliquerTunnelResponse> {
        const response = await this.duplicateFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activer un tunnel
     */
    async enableFunnelRaw(requestParameters: EnableFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling enableFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/enable`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Activer un tunnel
     */
    async enableFunnel(requestParameters: EnableFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.enableFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Réactiver une garantie du tunnel
     */
    async enableGuaranteeTunnelRaw(requestParameters: EnableGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling enableGuaranteeTunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/{garantieTunnelId}/enable`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Réactiver une garantie du tunnel
     */
    async enableGuaranteeTunnel(requestParameters: EnableGuaranteeTunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.enableGuaranteeTunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes (products, branches, plateformes, active). Permission BackOffice.AdminTunnels.Read. 
     * Facettes de la liste admin des tunnels (BO admin)
     */
    async getAdminTunnelListFacetsRaw(requestParameters: GetAdminTunnelListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminTunnelListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes (products, branches, plateformes, active). Permission BackOffice.AdminTunnels.Read. 
     * Facettes de la liste admin des tunnels (BO admin)
     */
    async getAdminTunnelListFacets(requestParameters: GetAdminTunnelListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminTunnelListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des tunnels avec facettes/tri. Permission BackOffice.AdminTunnels.Read. filters : productIds, branchIds, plateformeIds, active, period. 
     * Lister les tunnels (BO admin)
     */
    async getAdminTunnelsRaw(requestParameters: GetAdminTunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTunnelAdminListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminTunnels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTunnelAdminListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des tunnels avec facettes/tri. Permission BackOffice.AdminTunnels.Read. filters : productIds, branchIds, plateformeIds, active, period. 
     * Lister les tunnels (BO admin)
     */
    async getAdminTunnels(requestParameters: GetAdminTunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTunnelAdminListResponse> {
        const response = await this.getAdminTunnelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Valideurs disponibles d\'une plateforme pour un tunnel
     */
    async getFunnelAvailableValidatorsRaw(requestParameters: GetFunnelAvailableValidatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListValideursDisponiblesResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelAvailableValidators().'
            );
        }

        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getFunnelAvailableValidators().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/plateformes/{plateformeId}/valideurs-disponibles`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListValideursDisponiblesResponseFromJSON(jsonValue));
    }

    /**
     * Valideurs disponibles d\'une plateforme pour un tunnel
     */
    async getFunnelAvailableValidators(requestParameters: GetFunnelAvailableValidatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListValideursDisponiblesResponse> {
        const response = await this.getFunnelAvailableValidatorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'un tunnel
     */
    async getFunnelDetailRaw(requestParameters: GetFunnelDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunnelDetailDto>> {
        if (requestParameters['funnelId'] == null) {
            throw new runtime.RequiredError(
                'funnelId',
                'Required parameter "funnelId" was null or undefined when calling getFunnelDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{funnelId}`.replace(`{${"funnelId"}}`, encodeURIComponent(String(requestParameters['funnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunnelDetailDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'un tunnel
     */
    async getFunnelDetail(requestParameters: GetFunnelDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunnelDetailDto> {
        const response = await this.getFunnelDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'un frais du tunnel
     */
    async getFunnelFeeRaw(requestParameters: GetFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FraisTunnelDetailDto>> {
        if (requestParameters['fraisTunnelId'] == null) {
            throw new runtime.RequiredError(
                'fraisTunnelId',
                'Required parameter "fraisTunnelId" was null or undefined when calling getFunnelFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-tunnels/{fraisTunnelId}/optim`.replace(`{${"fraisTunnelId"}}`, encodeURIComponent(String(requestParameters['fraisTunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FraisTunnelDetailDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'un frais du tunnel
     */
    async getFunnelFee(requestParameters: GetFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FraisTunnelDetailDto> {
        const response = await this.getFunnelFeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Frais d\'un tunnel
     */
    async getFunnelFeesRaw(requestParameters: GetFunnelFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFraisTunnelResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-tunnels/tunnels/{tunnelId}`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFraisTunnelResponseFromJSON(jsonValue));
    }

    /**
     * Frais d\'un tunnel
     */
    async getFunnelFees(requestParameters: GetFunnelFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFraisTunnelResponse> {
        const response = await this.getFunnelFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'une garantie du tunnel
     */
    async getFunnelGuaranteeRaw(requestParameters: GetFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GarantieTunnelDetailDto>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling getFunnelGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/{garantieTunnelId}/optim`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GarantieTunnelDetailDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'une garantie du tunnel
     */
    async getFunnelGuarantee(requestParameters: GetFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GarantieTunnelDetailDto> {
        const response = await this.getFunnelGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail de tarification d\'une garantie
     */
    async getFunnelGuaranteePricingDetailsRaw(requestParameters: GetFunnelGuaranteePricingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GarantieTarifDto>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling getFunnelGuaranteePricingDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/{garantieTunnelId}/details-tarif-optim`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GarantieTarifDtoFromJSON(jsonValue));
    }

    /**
     * Détail de tarification d\'une garantie
     */
    async getFunnelGuaranteePricingDetails(requestParameters: GetFunnelGuaranteePricingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GarantieTarifDto> {
        const response = await this.getFunnelGuaranteePricingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Garanties d\'un tunnel
     */
    async getFunnelGuaranteesRaw(requestParameters: GetFunnelGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GarantieTunnelListItemDto>>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelGuarantees().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tunnelId'] != null) {
            queryParameters['tunnelId'] = requestParameters['tunnelId'];
        }

        if (requestParameters['isTunnelGLI'] != null) {
            queryParameters['isTunnelGLI'] = requestParameters['isTunnelGLI'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GarantieTunnelListItemDtoFromJSON));
    }

    /**
     * Garanties d\'un tunnel
     */
    async getFunnelGuarantees(requestParameters: GetFunnelGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GarantieTunnelListItemDto>> {
        const response = await this.getFunnelGuaranteesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configuration parc des frais d\'un tunnel
     */
    async getFunnelParkFeesConfigRaw(requestParameters: GetFunnelParkFeesConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFraisParcConfigResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelParkFeesConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/frais-parc-config`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFraisParcConfigResponseFromJSON(jsonValue));
    }

    /**
     * Configuration parc des frais d\'un tunnel
     */
    async getFunnelParkFeesConfig(requestParameters: GetFunnelParkFeesConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFraisParcConfigResponse> {
        const response = await this.getFunnelParkFeesConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail de tarification d\'un tunnel
     */
    async getFunnelPricingDetailsRaw(requestParameters: GetFunnelPricingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TarificationDetailsDto>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelPricingDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/details-tarif-optim`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TarificationDetailsDtoFromJSON(jsonValue));
    }

    /**
     * Détail de tarification d\'un tunnel
     */
    async getFunnelPricingDetails(requestParameters: GetFunnelPricingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TarificationDetailsDto> {
        const response = await this.getFunnelPricingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supports autorisés sur un tunnel
     */
    async getFunnelSupportsRaw(requestParameters: GetFunnelSupportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportTunnelDto>>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelSupports().'
            );
        }

        if (requestParameters['isTunnelGLI'] == null) {
            throw new runtime.RequiredError(
                'isTunnelGLI',
                'Required parameter "isTunnelGLI" was null or undefined when calling getFunnelSupports().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tunnelId'] != null) {
            queryParameters['tunnelId'] = requestParameters['tunnelId'];
        }

        if (requestParameters['isTunnelGLI'] != null) {
            queryParameters['isTunnelGLI'] = requestParameters['isTunnelGLI'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/supports-tunnels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportTunnelDtoFromJSON));
    }

    /**
     * Supports autorisés sur un tunnel
     */
    async getFunnelSupports(requestParameters: GetFunnelSupportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportTunnelDto>> {
        const response = await this.getFunnelSupportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configuration de la validation des devis d\'un tunnel
     */
    async getFunnelValidationConfigRaw(requestParameters: GetFunnelValidationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTunnelValidationConfigResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getFunnelValidationConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTunnelValidationConfigResponseFromJSON(jsonValue));
    }

    /**
     * Configuration de la validation des devis d\'un tunnel
     */
    async getFunnelValidationConfig(requestParameters: GetFunnelValidationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTunnelValidationConfigResponse> {
        const response = await this.getFunnelValidationConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get funnels
     */
    async getFunnelsRaw(requestParameters: GetFunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFunnelListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getFunnels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFunnelListResponseFromJSON(jsonValue));
    }

    /**
     * Get funnels
     */
    async getFunnels(requestParameters: GetFunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFunnelListResponse> {
        const response = await this.getFunnelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'une commission de garantie
     */
    async getGuaranteeCommissionRaw(requestParameters: GetGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommissionGarantieDetailDto>> {
        if (requestParameters['commissionGarantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'commissionGarantieTunnelId',
                'Required parameter "commissionGarantieTunnelId" was null or undefined when calling getGuaranteeCommission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-garanties-tunnels/{commissionGarantieTunnelId}/optim`.replace(`{${"commissionGarantieTunnelId"}}`, encodeURIComponent(String(requestParameters['commissionGarantieTunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommissionGarantieDetailDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'une commission de garantie
     */
    async getGuaranteeCommission(requestParameters: GetGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommissionGarantieDetailDto> {
        const response = await this.getGuaranteeCommissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Commissions d\'une garantie du tunnel
     */
    async getGuaranteeCommissionsRaw(requestParameters: GetGuaranteeCommissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGarantieCommissionsResponse>> {
        if (requestParameters['garantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'garantieTunnelId',
                'Required parameter "garantieTunnelId" was null or undefined when calling getGuaranteeCommissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/remunerations-garanties-tunnels/garanties-tunnels/{garantieTunnelId}`.replace(`{${"garantieTunnelId"}}`, encodeURIComponent(String(requestParameters['garantieTunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGarantieCommissionsResponseFromJSON(jsonValue));
    }

    /**
     * Commissions d\'une garantie du tunnel
     */
    async getGuaranteeCommissions(requestParameters: GetGuaranteeCommissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGarantieCommissionsResponse> {
        const response = await this.getGuaranteeCommissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get audit history for a tunnel
     */
    async getTunnelAuditHistoryRaw(requestParameters: GetTunnelAuditHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTunnelAuditHistoryResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getTunnelAuditHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/audit-history`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTunnelAuditHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get audit history for a tunnel
     */
    async getTunnelAuditHistory(requestParameters: GetTunnelAuditHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTunnelAuditHistoryResponse> {
        const response = await this.getTunnelAuditHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link plateformes to funnel
     */
    async linkPlateformesRaw(requestParameters: LinkPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['funnelId'] == null) {
            throw new runtime.RequiredError(
                'funnelId',
                'Required parameter "funnelId" was null or undefined when calling linkPlateformes().'
            );
        }

        if (requestParameters['genericLinkPlateformesCommand'] == null) {
            throw new runtime.RequiredError(
                'genericLinkPlateformesCommand',
                'Required parameter "genericLinkPlateformesCommand" was null or undefined when calling linkPlateformes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{funnelId}`.replace(`{${"funnelId"}}`, encodeURIComponent(String(requestParameters['funnelId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: GenericLinkPlateformesCommandToJSON(requestParameters['genericLinkPlateformesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link plateformes to funnel
     */
    async linkPlateformes(requestParameters: LinkPlateformesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkPlateformesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retirer un valideur du tunnel
     */
    async removeFunnelValidatorRaw(requestParameters: RemoveFunnelValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling removeFunnelValidator().'
            );
        }

        if (requestParameters['valideurId'] == null) {
            throw new runtime.RequiredError(
                'valideurId',
                'Required parameter "valideurId" was null or undefined when calling removeFunnelValidator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/valideurs/{valideurId}`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"valideurId"}}`, encodeURIComponent(String(requestParameters['valideurId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Retirer un valideur du tunnel
     */
    async removeFunnelValidator(requestParameters: RemoveFunnelValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.removeFunnelValidatorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Réinitialiser la configuration parc d\'un frais
     */
    async resetFunnelParkFeeConfigRaw(requestParameters: ResetFunnelParkFeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling resetFunnelParkFeeConfig().'
            );
        }

        if (requestParameters['remunerationTunnelId'] == null) {
            throw new runtime.RequiredError(
                'remunerationTunnelId',
                'Required parameter "remunerationTunnelId" was null or undefined when calling resetFunnelParkFeeConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/frais-parc-config/{remunerationTunnelId}`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"remunerationTunnelId"}}`, encodeURIComponent(String(requestParameters['remunerationTunnelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Réinitialiser la configuration parc d\'un frais
     */
    async resetFunnelParkFeeConfig(requestParameters: ResetFunnelParkFeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.resetFunnelParkFeeConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enregistrer la configuration parc d\'un frais
     */
    async saveFunnelParkFeeConfigRaw(requestParameters: SaveFunnelParkFeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling saveFunnelParkFeeConfig().'
            );
        }

        if (requestParameters['remunerationTunnelId'] == null) {
            throw new runtime.RequiredError(
                'remunerationTunnelId',
                'Required parameter "remunerationTunnelId" was null or undefined when calling saveFunnelParkFeeConfig().'
            );
        }

        if (requestParameters['saveFraisParcConfigCommand'] == null) {
            throw new runtime.RequiredError(
                'saveFraisParcConfigCommand',
                'Required parameter "saveFraisParcConfigCommand" was null or undefined when calling saveFunnelParkFeeConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/frais-parc-config/{remunerationTunnelId}`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"remunerationTunnelId"}}`, encodeURIComponent(String(requestParameters['remunerationTunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveFraisParcConfigCommandToJSON(requestParameters['saveFraisParcConfigCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Enregistrer la configuration parc d\'un frais
     */
    async saveFunnelParkFeeConfig(requestParameters: SaveFunnelParkFeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.saveFunnelParkFeeConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rendre la validation optionnelle ou obligatoire pour un courtier
     */
    async setFunnelBrokerOptionalValidationRaw(requestParameters: SetFunnelBrokerOptionalValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelBrokerOptionalValidation().'
            );
        }

        if (requestParameters['courtierId'] == null) {
            throw new runtime.RequiredError(
                'courtierId',
                'Required parameter "courtierId" was null or undefined when calling setFunnelBrokerOptionalValidation().'
            );
        }

        if (requestParameters['setCourtierValidationOptionnelleCommand'] == null) {
            throw new runtime.RequiredError(
                'setCourtierValidationOptionnelleCommand',
                'Required parameter "setCourtierValidationOptionnelleCommand" was null or undefined when calling setFunnelBrokerOptionalValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/courtiers/{courtierId}/optionnelle`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"courtierId"}}`, encodeURIComponent(String(requestParameters['courtierId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetCourtierValidationOptionnelleCommandToJSON(requestParameters['setCourtierValidationOptionnelleCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Rendre la validation optionnelle ou obligatoire pour un courtier
     */
    async setFunnelBrokerOptionalValidation(requestParameters: SetFunnelBrokerOptionalValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelBrokerOptionalValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Désigner le valideur principal du tunnel
     */
    async setFunnelMainValidatorRaw(requestParameters: SetFunnelMainValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelMainValidator().'
            );
        }

        if (requestParameters['valideurId'] == null) {
            throw new runtime.RequiredError(
                'valideurId',
                'Required parameter "valideurId" was null or undefined when calling setFunnelMainValidator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/valideurs/{valideurId}/principal`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"valideurId"}}`, encodeURIComponent(String(requestParameters['valideurId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Désigner le valideur principal du tunnel
     */
    async setFunnelMainValidator(requestParameters: SetFunnelMainValidatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelMainValidatorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rendre la validation optionnelle ou obligatoire pour tous les courtiers
     */
    async setFunnelOptionalValidationForAllRaw(requestParameters: SetFunnelOptionalValidationForAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelOptionalValidationForAll().'
            );
        }

        if (requestParameters['setValidationOptionnellePourTousCommand'] == null) {
            throw new runtime.RequiredError(
                'setValidationOptionnellePourTousCommand',
                'Required parameter "setValidationOptionnellePourTousCommand" was null or undefined when calling setFunnelOptionalValidationForAll().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/courtiers/optionnelle`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetValidationOptionnellePourTousCommandToJSON(requestParameters['setValidationOptionnellePourTousCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Rendre la validation optionnelle ou obligatoire pour tous les courtiers
     */
    async setFunnelOptionalValidationForAll(requestParameters: SetFunnelOptionalValidationForAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelOptionalValidationForAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activer ou désactiver la validation des devis d\'un tunnel
     */
    async setFunnelValidationRequiredRaw(requestParameters: SetFunnelValidationRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelValidationRequired().'
            );
        }

        if (requestParameters['setValidationRequiseCommand'] == null) {
            throw new runtime.RequiredError(
                'setValidationRequiseCommand',
                'Required parameter "setValidationRequiseCommand" was null or undefined when calling setFunnelValidationRequired().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/requise`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetValidationRequiseCommandToJSON(requestParameters['setValidationRequiseCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Activer ou désactiver la validation des devis d\'un tunnel
     */
    async setFunnelValidationRequired(requestParameters: SetFunnelValidationRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelValidationRequiredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Définir le périmètre (courtiers) d\'un valideur du tunnel
     */
    async setFunnelValidatorBrokersRaw(requestParameters: SetFunnelValidatorBrokersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelValidatorBrokers().'
            );
        }

        if (requestParameters['valideurId'] == null) {
            throw new runtime.RequiredError(
                'valideurId',
                'Required parameter "valideurId" was null or undefined when calling setFunnelValidatorBrokers().'
            );
        }

        if (requestParameters['setTunnelValideurCourtiersCommand'] == null) {
            throw new runtime.RequiredError(
                'setTunnelValideurCourtiersCommand',
                'Required parameter "setTunnelValideurCourtiersCommand" was null or undefined when calling setFunnelValidatorBrokers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/valideurs/{valideurId}/courtiers`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))).replace(`{${"valideurId"}}`, encodeURIComponent(String(requestParameters['valideurId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetTunnelValideurCourtiersCommandToJSON(requestParameters['setTunnelValideurCourtiersCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Définir le périmètre (courtiers) d\'un valideur du tunnel
     */
    async setFunnelValidatorBrokers(requestParameters: SetFunnelValidatorBrokersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelValidatorBrokersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Définir les variables du tunnel modifiables par le valideur
     */
    async setFunnelValidatorVariablesRaw(requestParameters: SetFunnelValidatorVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling setFunnelValidatorVariables().'
            );
        }

        if (requestParameters['setVariablesValideurCommand'] == null) {
            throw new runtime.RequiredError(
                'setVariablesValideurCommand',
                'Required parameter "setVariablesValideurCommand" was null or undefined when calling setFunnelValidatorVariables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels/{tunnelId}/validation/variables`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetVariablesValideurCommandToJSON(requestParameters['setVariablesValideurCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Définir les variables du tunnel modifiables par le valideur
     */
    async setFunnelValidatorVariables(requestParameters: SetFunnelValidatorVariablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setFunnelValidatorVariablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mettre à jour un tunnel
     */
    async updateFunnelRaw(requestParameters: UpdateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['updateFunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'updateFunnelCommand',
                'Required parameter "updateFunnelCommand" was null or undefined when calling updateFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/tunnels`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFunnelCommandToJSON(requestParameters['updateFunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Mettre à jour un tunnel
     */
    async updateFunnel(requestParameters: UpdateFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier un frais du tunnel
     */
    async updateFunnelFeeRaw(requestParameters: UpdateFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['fraisTunnelId'] == null) {
            throw new runtime.RequiredError(
                'fraisTunnelId',
                'Required parameter "fraisTunnelId" was null or undefined when calling updateFunnelFee().'
            );
        }

        if (requestParameters['updateFraisTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'updateFraisTunnelCommand',
                'Required parameter "updateFraisTunnelCommand" was null or undefined when calling updateFunnelFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/remunerations-tunnels/{fraisTunnelId}/optim`.replace(`{${"fraisTunnelId"}}`, encodeURIComponent(String(requestParameters['fraisTunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFraisTunnelCommandToJSON(requestParameters['updateFraisTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Modifier un frais du tunnel
     */
    async updateFunnelFee(requestParameters: UpdateFunnelFeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateFunnelFeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier une garantie du tunnel
     */
    async updateFunnelGuaranteeRaw(requestParameters: UpdateFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GarantieTunnelListItemDto>> {
        if (requestParameters['updateGarantieTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'updateGarantieTunnelCommand',
                'Required parameter "updateGarantieTunnelCommand" was null or undefined when calling updateFunnelGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/garanties-tunnels/optim`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGarantieTunnelCommandToJSON(requestParameters['updateGarantieTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GarantieTunnelListItemDtoFromJSON(jsonValue));
    }

    /**
     * Modifier une garantie du tunnel
     */
    async updateFunnelGuarantee(requestParameters: UpdateFunnelGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GarantieTunnelListItemDto> {
        const response = await this.updateFunnelGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier un support autorisé
     */
    async updateFunnelSupportRaw(requestParameters: UpdateFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportTunnelDto>> {
        if (requestParameters['updateSupportTunnelCommand'] == null) {
            throw new runtime.RequiredError(
                'updateSupportTunnelCommand',
                'Required parameter "updateSupportTunnelCommand" was null or undefined when calling updateFunnelSupport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/supports-tunnels`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupportTunnelCommandToJSON(requestParameters['updateSupportTunnelCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTunnelDtoFromJSON(jsonValue));
    }

    /**
     * Modifier un support autorisé
     */
    async updateFunnelSupport(requestParameters: UpdateFunnelSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportTunnelDto> {
        const response = await this.updateFunnelSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier une commission de garantie
     */
    async updateGuaranteeCommissionRaw(requestParameters: UpdateGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['commissionGarantieTunnelId'] == null) {
            throw new runtime.RequiredError(
                'commissionGarantieTunnelId',
                'Required parameter "commissionGarantieTunnelId" was null or undefined when calling updateGuaranteeCommission().'
            );
        }

        if (requestParameters['updateCommissionGarantieCommand'] == null) {
            throw new runtime.RequiredError(
                'updateCommissionGarantieCommand',
                'Required parameter "updateCommissionGarantieCommand" was null or undefined when calling updateGuaranteeCommission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/remunerations-garanties-tunnels/{commissionGarantieTunnelId}/optim`.replace(`{${"commissionGarantieTunnelId"}}`, encodeURIComponent(String(requestParameters['commissionGarantieTunnelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCommissionGarantieCommandToJSON(requestParameters['updateCommissionGarantieCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Modifier une commission de garantie
     */
    async updateGuaranteeCommission(requestParameters: UpdateGuaranteeCommissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateGuaranteeCommissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
